import { SVGProps, Ref, forwardRef, memo } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <g clipPath="url(#clip0_1044_2771)">
      <path
        d="M0.702148 8.91211V9.72717C0.702148 10.1595 0.873894 10.5742 1.17961 10.8799C1.48533 11.1856 1.89996 11.3574 2.33231 11.3574H9.66806C10.1004 11.3574 10.515 11.1856 10.8207 10.8799C11.1264 10.5742 11.2982 10.1595 11.2982 9.72717V8.91211"
        stroke={props?.stroke || '#CCCCCC'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.83154 3.45508C8.27617 2.43294 7.44899 1.50145 6.38338 0.857207C6.14737 0.714527 5.8522 0.714536 5.61621 0.857233C4.55065 1.50152 3.72348 2.43296 3.16808 3.45508"
        stroke={props?.stroke || '#CCCCCC'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 0.856304L6 7.94531"
        stroke={props?.stroke || '#CCCCCC'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1044_2771">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const ForwardRef = forwardRef(SvgComponent);
const UploadIcon = memo(ForwardRef);
export default UploadIcon;
